import { useState } from "react";
import { useParams } from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { Box, IconButton, Tab, Tabs } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { Contract } from "./Contract/Contract";
import { TableInstallments } from "./Installments/table/TableInstallments";
import { TableContractsFiles } from "./Files/Components/table/TableContractsFiles";
import { ContractInternalDashboard } from "./Dashboard";
import { LinkCore } from "src/Pages/components/LinkCore/LinkCore";
import { UrlConfig } from "src/shared/Utils/paths";

export const ContractInternal = () => {
  const { id } = useParams();

  const [value, setValue] = useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  if (!id) return null;

  return (
    <Box>
      <TabContext value={value}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 3 }}
        >
          <LinkCore to={UrlConfig.lancamentos.contratos.url}>
            <IconButton aria-label="back" sx={{ mb: -3 }}>
              <ArrowBackIcon />
            </IconButton>
          </LinkCore>

          <Tab label="Contrato" value="1" />
          <Tab label="Parcelas" value="2" />
          <Tab label="Arquivos" value="3" />
          <Tab label="Dashboard" value="4" />
        </Tabs>

        <TabPanel sx={{ padding: 0 }} value="1">
          <Contract idContract={id} />
        </TabPanel>

        <TabPanel sx={{ padding: 0 }} value="2">
          <TableInstallments idContract={id} />
        </TabPanel>

        <TabPanel sx={{ padding: 0 }} value="3">
          <TableContractsFiles idContract={id} />
        </TabPanel>

        <TabPanel sx={{ padding: 0 }} value="4">
          <ContractInternalDashboard idContract={id} />
        </TabPanel>
      </TabContext>
    </Box>
  );
};
